import React from 'react';

import gal1 from '../images/gal (1).png';
import gal2 from '../images/gal (2).png';
import gal3 from '../images/gal (3).png';
import gal4 from '../images/gal (4).png';
import gal5 from '../images/gal (5).png';
import gal6 from '../images/gal (6).png';

const Photoes = () => {
  const images = [gal1, gal2, gal3, gal4, gal5, gal6];

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4 fw-bold">Our Images</h2>
      <div className="row g-4">
        {images.map((img, index) => (
          <div className="col-sm-6 col-md-4" key={index}>
            <div className="card h-100 shadow-sm border-0">
              <img
                src={img}
                alt={`homeopathy-${index + 1}`}
                className="card-img-top rounded"
                style={{ objectFit: 'cover', height: '250px' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Photoes;
